<template>
  <div>
    <van-image width="100%" fit="cover" :src="require('@/assets/image/signday_top.png')" style="z-index: -1;"/>
    <div class="q_pad_lr15px q_sign_day">
      <div class="q_back_white q_bor_5 q_pad_15px q_shadow_gray" v-if="signList[0]!=null">
        <div>您已连续签到<span class="q_bold q_color_default q_mar_lr5px">{{ lastingSign }}</span>天</div>
        <van-row gutter="10" class="q_mar_t15px">
          <van-col span="6">
            <div v-if="day < 2" class="q_center q_sday">
              <div>第1天</div>
              <img v-if="day < 2" src="../../assets/image/day.png" style="width: 40%;"/>
              <img v-if="day > 1" src="../../assets/image/dayed.png" style="width: 40%;"/>
              <div class="q_text_s q_color_gray">{{ signList[0].integral }}积分</div>
            </div>
            <div v-if="day > 1" class="q_center q_sday q_sdayed">
              <div>第1天</div>
              <img v-if="day < 2" src="../../assets/image/day.png" style="width: 40%;"/>
              <img v-if="day > 1" src="../../assets/image/dayed.png" style="width: 40%;"/>
              <div class="q_text_s q_color_gray">{{ signList[0].integral }}积分</div>
            </div>
          </van-col>
          <van-col span="6">
            <div v-if="(day < 3)" class="q_center q_sday">
              <div>第2天</div>
              <img v-if="(day < 3)" src="../../assets/image/day.png" style="width: 40%;"/>
              <img v-if="day > 2" src="../../assets/image/dayed.png" style="width: 40%;"/>
              <div class="q_text_s q_color_gray">{{ signList[1].integral }}积分</div>
            </div>
            <div v-if="day > 2" class="q_center q_sday q_sdayed">
              <div>第2天</div>
              <img v-if="(day < 3)" src="../../assets/image/day.png" style="width: 40%;"/>
              <img v-if="day > 2" src="../../assets/image/dayed.png" style="width: 40%;"/>
              <div class="q_text_s q_color_gray">{{ signList[1].integral }}积分</div>
            </div>
          </van-col>
          <van-col span="6">
            <div v-if="(day < 4)" class="q_center q_sday">
              <div>第3天</div>
              <img v-if="(day < 4)" src="../../assets/image/day.png" style="width: 40%;"/>
              <img v-if="day > 3" src="../../assets/image/dayed.png" style="width: 40%;"/>
              <div class="q_text_s q_color_gray">{{ signList[2].integral }}积分</div>
            </div>
            <div v-if="day > 3" class="q_center q_sday q_sdayed">
              <div>第3天</div>
              <img v-if="(day < 4)" src="../../assets/image/day.png" style="width: 40%;"/>
              <img v-if="day > 3" src="../../assets/image/dayed.png" style="width: 40%;"/>
              <div class="q_text_s q_color_gray">{{ signList[2].integral }}积分</div>
            </div>
          </van-col>
          <van-col span="6">
            <div v-if="(day < 5)" class="q_center q_sday">
              <div>第4天</div>
              <img v-if="(day < 5)" src="../../assets/image/day.png" style="width: 40%;"/>
              <img v-if="day > 4" src="../../assets/image/dayed.png" style="width: 40%;"/>
              <div class="q_text_s q_color_gray">{{ signList[3].integral }}积分</div>
            </div>
            <div v-if="day > 4" class="q_center q_sday q_sdayed">
              <div>第4天</div>
              <img v-if="(day < 5)" src="../../assets/image/day.png" style="width: 40%;"/>
              <img v-if="day > 4" src="../../assets/image/dayed.png" style="width: 40%;"/>
              <div class="q_text_s q_color_gray">{{ signList[3].integral }}积分</div>
            </div>
          </van-col>
        </van-row>
        <van-row gutter="10" class="q_mar_t15px">
          <van-col span="6">
            <div v-if="(day < 6)" class="q_center q_sday">
              <div>第5天</div>
              <img v-if="(day < 6)" src="../../assets/image/day.png" style="width: 40%;"/>
              <img v-if="day > 5" src="../../assets/image/dayed.png" style="width: 40%;"/>
              <div class="q_text_s q_color_gray">{{ signList[4].integral }}积分</div>
            </div>
            <div v-if="day > 5" class="q_center q_sday q_sdayed">
              <div>第5天</div>
              <img v-if="(day < 6)" src="../../assets/image/day.png" style="width: 40%;"/>
              <img v-if="day > 5" src="../../assets/image/dayed.png" style="width: 40%;"/>
              <div class="q_text_s q_color_gray">{{ signList[4].integral }}积分</div>
            </div>

          </van-col>
          <van-col span="6">
            <div v-if="(day < 7)" class="q_center q_sday">
              <div>第6天</div>
              <img v-if="(day < 7)" src="../../assets/image/day.png" style="width: 40%;"/>
              <img v-if="day > 6" src="../../assets/image/dayed.png" style="width: 40%;"/>
              <div class="q_text_s q_color_gray">{{ signList[5].integral }}积分</div>
            </div>

            <div v-if="day > 6" class="q_center q_sday q_sdayed">
              <div>第6天</div>
              <img v-if="(day < 7)" src="../../assets/image/day.png" style="width: 40%;"/>
              <img v-if="day > 6" src="../../assets/image/dayed.png" style="width: 40%;"/>
              <div class="q_text_s q_color_gray">{{ signList[5].integral }}积分</div>
            </div>
          </van-col>
          <van-col span="12">
            <div v-if="day != 8" class="q_sday">
              <div class="q_inlineblock q_left q_mar_l10px" style="vertical-align: top;">
                <div>第7天</div>
                <div class="q_text_s q_color_gray">{{ signList[6].integral }}积分</div>
              </div>
              <img src="../../assets/image/days.png" style="width: 40%;bottom: 2vw;right: 2vw;"
                   class="q_po_ab"/>
              <div class="q_clear"></div>
            </div>
            <div v-if="day == 8" class="q_sday q_sdayed">
              <div class="q_inlineblock q_left q_mar_l10px" style="vertical-align: top;">
                <div>第7天</div>
                <div class="q_text_s q_color_gray">{{ signList[6].integral }}积分</div>
              </div>
              <img src="../../assets/image/days.png" style="width: 40%;bottom: 2vw;right: 2vw;"
                   class="q_po_ab"/>
              <div class="q_clear"></div>
            </div>
          </van-col>
        </van-row>
        <div class="q_center q_mar_t20px">
          <van-button v-if="this.isSign != 1" class="q_btn_sign" round color="#FF5733" @click="showPopup">签到领积分
          </van-button>
          <van-button v-if="this.isSign == 1" disabled class="q_btn_sign" round color="#FF5733">今日已签到</van-button>
        </div>
      </div>
      <div class="q_mar_t15px q_back_white q_pad_15px q_bor_5 q_shadow_gray">
        <div class="q_bold">规则说明</div>
        <div class="q_color_gray q_mar_t10px q_text_s" style="line-height: 1.5em;">
          <p>1、连续签到一个周期，即可获得更多积分。</p>
          <p>2、如果签到中断，则下次重新开始累计。</p>
          <p>3、连续签到以每7天为一个周期。</p>
          <p>4、积分可用于兑换爱心商品。</p>
        </div>
      </div>
    </div>
    <van-popup v-model="show" round>
      <div class="q_pad_20px q_center">
        <img src="../../assets/image/sign_su.png" width="100%"/>
        <div class="q_color_default q_text_l q_mar_t20px">签到成功</div>
        <div class="q_mar_t5px q_mar_b20px">今日签到获得<span class="q_color_default q_mar_lr5px">{{ sign.integral }}</span>积分
        </div>
        <van-button class="q_btn_sign" round color="#FF5733" @click="roger">我知道了</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {listSign} from "@/api/sign";
import {addUserSign, userDay} from "@/api/userSign";
import {wxCloseShare} from "@/utils/jiutang";

export default {
  name: 'Signday',
  props: {
    msg: String
  },
  data() {
    return {
      show: false,
      signList: [],
      day: 0,
      isSign: 0,
      sign: {},
      //连续签到
      lastingSign: 0,
    }
  },
  created() {
    wxCloseShare()
    this.init()
  },
  methods: {
    /**
     * 初始化
     */
    init() {
      this.$modal.loading()
      //获取签到积分信息
      listSign().then((res) => {
        this.signList = res.rows
        return userDay()
      }).then(res => {
        //获取用户当前是第几天签到
        this.day = res.data.day
        this.isSign = res.data.isSign
        this.sign = res.data.sign
        if (res.data.sign == 1) {
          //今日已签到
          this.lastingSign = res.data.day
        } else {
          this.lastingSign = res.data.day - 1
        }
      }).finally(() => {
        this.$modal.closeLoading()
      })
    },
    showPopup() {
      //判断今日是否已经签到过了
      if (this.isSign == 1) {
        return this.$modal.alert("今日已签到");
      }
      this.show = true;
      //增加签到记录
      addUserSign(this.day, this.sign.integral).then((res) => {
        this.init()
      })
    },
    //我知道了
    roger() {
      this.show = false
      this.init()
    }
  }
}
</script>
<style scoped="scoped">
.q_sign_day {
  margin-top: -80px;
}

.q_sday {
  padding: 10px 0;
  background-color: #F2F3F7;
  border-radius: 5px;
  height: 86.5px;
  position: relative;
}

.q_sdayed {
  background-color: #FF5733;
}

.q_sdayed * {
  color: #FFffff !important;
}

.q_btn_sign {
  width: 50vw;
}
</style>
